import { render } from "./chooseIcons.vue?vue&type=template&id=6446d2c6&scoped=true"
import script from "./chooseIcons.vue?vue&type=script&lang=js"
export * from "./chooseIcons.vue?vue&type=script&lang=js"

import "./chooseIcons.vue?vue&type=style&index=0&id=6446d2c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6446d2c6"]])

export default __exports__